import React, { Fragment } from "react";
import moment from "moment";
import styled from "styled-components";
import {
  ActionHeading,
  IconButton,
  SnoozeOutline,
  SnoozeTimeOutline,
} from "@conserveit/blocks";
import Menu from "../../Menu";
import { $Menu } from "../../Menu/Menu.styles";
import { SnoozeMenu } from "../../../containers/SnoozeMenu";

function getSnoozedLength(endUnixTime) {
  return `for ${moment.unix(endUnixTime).fromNow()}`;
}

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  border: none;
  font-size: 14px;
  background: none;
`;

function showList({ isOpen }) {
  return isOpen ? "block" : "none";
}
const $List = styled($Menu)`
  display: ${showList};
  left: auto;
  right: 0;
  top: 0;
`;

const Remaining = styled.span`
  display: inline-block;
  margin-left: 2px;
  font-size: 10px;
`;

const RowAction = ({
  className,
  onMenuToggle,
  equipRuleId,
  isSnoozed,
  snoozeEnd,
  isHidden,
}) => (
  <Menu onToggle={onMenuToggle}>
    {({ isOpen, menuRef, toggle, close }) => (
      <Wrapper className={className} ref={menuRef} data-cy="RowSnooze" hidden={isHidden}>
        <Label data-cy="RowSnooze-Icon">
          {isSnoozed ? (
            <IconButton onClick={toggle} icon={<SnoozeTimeOutline />} />
          ) : (
            <IconButton onClick={toggle} icon={<SnoozeOutline />} />
          )}
        </Label>
        <$List isOpen={isOpen}>
          {!isSnoozed && (
            <Fragment>
              <ActionHeading>Snooze</ActionHeading>
              <SnoozeMenu equipRuleIds={[equipRuleId]} onClick={close} />
            </Fragment>
          )}
          {isSnoozed && (
            <Fragment>
              <ActionHeading>
                <span>Snoozed</span>
                <Remaining>({getSnoozedLength(snoozeEnd)})</Remaining>
              </ActionHeading>
              <SnoozeMenu
                equipRuleIds={[equipRuleId]}
                onClick={close}
                showUnsnooze
                showSnooze={false}
              />
            </Fragment>
          )}
        </$List>
      </Wrapper>
    )}
  </Menu>
);

export default RowAction;
